import { useEffect, useState } from 'react'
import { InspectionVariableFeeTemplate, SiteFeeConfig, VariableFeesOverview } from '../../../types/VariableFee'
import { useSites } from '../../../hooks/useSites'
import { getDefaultFeeRows } from '../constants'
import BackOfficeAPIClient from '../../../clients/BackofficeAPIClient'
import { applyDataToRows, buildBrandConfigs, buildSummary, groupByDealershipId } from '../utils/variableFeeUtils'
import { buildSaveTargetQuery, SaveTarget } from '../moduleVoNavigation'

const backofficeApiClient = new BackOfficeAPIClient()

// Charge toutes les lignes en une fois et les répartit en 3 listes pour la page d'aperçu :
// global, par site (avec repli global par ligne), par marque (cf. buildBrandConfigs).
export function useVariableFeesOverview(): VariableFeesOverview {
    const sites = useSites()
    const [ data, setData ] = useState<InspectionVariableFeeTemplate[]>([])

    const fetchData = () => {
        backofficeApiClient.get<InspectionVariableFeeTemplate[]>('/inspection-variable-fee-templates/overview')
            .then(setData)
            .catch(console.log)
    }

    useEffect(() => {
        fetchData()
    }, [])

    const deleteConfig = async (target: SaveTarget) => {
        const query = buildSaveTargetQuery(target)
        await backofficeApiClient.delete(`/inspection-variable-fee-templates${query}`, undefined)
        fetchData()
    }

    const siteNameById = new Map(sites.map(site => [ site.value, site.label ]))

    const globalData = data.filter(row => row.dealership_id === null && row.brand === null)
    const siteDataById = groupByDealershipId(data.filter(row => row.brand === null))
    const brandScopedData = data.filter(row => row.brand !== null)

    const siteConfigs: SiteFeeConfig[] = Array.from(siteDataById.entries()).map(([ dealershipId, siteRows ]) => ({
        dealershipId,
        siteName: siteNameById.get(dealershipId) ?? `Site ${dealershipId}`,
        ...buildSummary(applyDataToRows(applyDataToRows(getDefaultFeeRows(), globalData), siteRows)),
    }))

    return {
        sites: sites.map(site => ({ id: site.value, name: site.label })),
        brandConfigs: buildBrandConfigs(brandScopedData, siteNameById),
        siteConfigs,
        globalConfig: buildSummary(applyDataToRows(getDefaultFeeRows(), globalData)),
        deleteConfig,
    }
}
